import { useCallback, useEffect, useMemo, useState, } from 'react';
import { usePointerState } from '../../utils/usePointerState';
const defaultProps = {
    onFavoriteClick: () => { },
    onSwatchChange: () => { },
};
export const useProductCard = ({ featuredAttribute, isFavorite, onFavoriteClick = defaultProps.onFavoriteClick, onSwatchChange = defaultProps.onSwatchChange, productImageBadge, productImages, selectedImageIndex = 0, selectedSwatch, swatchOptions, }) => {
    const pointerState = usePointerState();
    const isFlatPagerVisible = useMemo(() => (pointerState === 'TOUCH'), [
        pointerState,
    ]);
    const [localSelectedImageIndex, setLocalSelectedImageIndex,] = useState(selectedImageIndex);
    const onLocalSelectedImageIndexChange = useCallback((index) => {
        setLocalSelectedImageIndex(index);
    }, []);
    const [localSelectedSwatch, setLocalSelectedSwatch,] = useState(selectedSwatch
        || (swatchOptions
            ? swatchOptions[0].value
            : undefined));
    const localProductImages = useMemo(() => ((productImages
        && swatchOptions)
        ? (productImages === null || productImages === void 0 ? void 0 : productImages.filter((productImage) => {
            var _a;
            return (localSelectedSwatch
                ? (swatchOptions === null || swatchOptions === void 0 ? void 0 : swatchOptions.find((swatchOption) => ((productImage === null || productImage === void 0 ? void 0 : productImage.colorwayId) === (swatchOption === null || swatchOption === void 0 ? void 0 : swatchOption.colorwayId)
                    && swatchOption.value === localSelectedSwatch)))
                : (productImage === null || productImage === void 0 ? void 0 : productImage.colorwayId) === ((_a = swatchOptions[0]) === null || _a === void 0 ? void 0 : _a.colorwayId));
        }))
        : productImages), [
        localSelectedSwatch,
        productImages,
        swatchOptions,
    ]);
    const localSelectedImage = useMemo(() => (localProductImages
        ? localProductImages[localSelectedImageIndex]
        : undefined), [
        localProductImages,
        localSelectedImageIndex,
    ]);
    const selectedSwatchOption = useMemo(() => (swatchOptions === null || swatchOptions === void 0 ? void 0 : swatchOptions.find((swatchOption) => (swatchOption.value === localSelectedSwatch))), [
        localSelectedSwatch,
        swatchOptions,
    ]);
    const localFeaturedAttribute = useMemo(() => ((localSelectedImage === null || localSelectedImage === void 0 ? void 0 : localSelectedImage.featuredAttribute)
        || (selectedSwatchOption === null || selectedSwatchOption === void 0 ? void 0 : selectedSwatchOption.featuredAttribute)
        || featuredAttribute), [
        featuredAttribute,
        localSelectedImage,
        selectedSwatchOption,
    ]);
    const localProductImageBadge = useMemo(() => ((localSelectedImage === null || localSelectedImage === void 0 ? void 0 : localSelectedImage.productImageBadge)
        || (selectedSwatchOption === null || selectedSwatchOption === void 0 ? void 0 : selectedSwatchOption.productImageBadge)
        || productImageBadge), [
        productImageBadge,
        localSelectedImage,
        selectedSwatchOption,
    ]);
    const handleSwatchChange = useCallback((event) => {
        if (swatchOptions) {
            const swatchValue = event.target.value;
            setLocalSelectedSwatch(swatchValue);
            if (onSwatchChange) {
                onSwatchChange(event);
            }
        }
    }, [
        onSwatchChange,
        swatchOptions,
    ]);
    const [localIsFavorite, setLocalIsFavorite,] = useState(isFavorite);
    const handleFavoriteClick = useCallback((event) => {
        if (onFavoriteClick) {
            onFavoriteClick(event);
            // TODO: We don't want to show that the favorite has been added until after we have received a success repsonse. TBD on how to handle that.
            setLocalIsFavorite((isFavorite) => (!isFavorite));
        }
    }, [
        onFavoriteClick,
    ]);
    useEffect(() => {
        setLocalIsFavorite(isFavorite);
    }, [
        isFavorite,
    ]);
    return {
        featuredAttribute: localFeaturedAttribute,
        isFavorite: localIsFavorite,
        isFlatPagerVisible,
        onFavoriteClick: handleFavoriteClick,
        onSelectedImageIndexChange: onLocalSelectedImageIndexChange,
        onSwatchChange: handleSwatchChange,
        productImageBadge: localProductImageBadge,
        productImages: localProductImages,
        selectedImageIndex: localSelectedImageIndex,
        selectedSwatch: localSelectedSwatch,
    };
};
